import './code-block.css';
export default {
  "codeBlock": "pf-v6-c-code-block",
  "codeBlockActions": "pf-v6-c-code-block__actions",
  "codeBlockCode": "pf-v6-c-code-block__code",
  "codeBlockContent": "pf-v6-c-code-block__content",
  "codeBlockHeader": "pf-v6-c-code-block__header",
  "codeBlockPre": "pf-v6-c-code-block__pre"
};